//@ts-nocheck
import { getConfig } from "../config/config";
import { decryptEnv } from "../helpers";
const { APP_BASE_API_URL, APP_BASE_SWARAJ_API_URL, APP_OCP_APIM_KEY, APP_HEAD_KEY, } = getConfig();
export const getIndicesDetails = async (companyName) => {
    var _a;
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${(_a = localStorage.getItem("JWTToken")) === null || _a === void 0 ? void 0 : _a.replace("JWTToken", "")} `);
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Ocp-Apim-Subscription-Key", decryptEnv(APP_OCP_APIM_KEY));
    const raw = JSON.stringify(companyName);
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };
    try {
        const response = await fetch(`${APP_BASE_API_URL}/tradeapi/IndicesDetailPage`, requestOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    }
    catch (error) {
        console.error("Error fetching indices details:", error);
        throw error;
    }
};
